import React from 'react';
import TeamListItem from './components/TeamListItem';
import PropTypes from 'prop-types';
import './styles.css';

const TeamList = ({ data, actions }) => {
  return (
    <div className="team-list">
      <div className="team-list__header">
        <div className="team-list__column">
          <div className="team-list__caption">Team Member</div>
        </div>
        <div className="team-list__column">
          <div className="team-list__caption">Messages Sent</div>
        </div>
        <div className="team-list__column">
          <div className="team-list__caption"># Of Rated Candidates</div>
        </div>
        <div className="team-list__column">
          <div className="team-list__caption">Average Rating</div>
        </div>
      </div>
      <div className="team-list__members">
        {data.map(item => {
          return (
            <TeamListItem
              key={item.RecruiterID}
              data={item}
              actions={actions}
            />
          );
        })}
      </div>
    </div>
  );
};

TeamList.propTypes = {
  data: PropTypes.array,
  actions: PropTypes.object,
};

export default TeamList;
